module.exports = __webpack_public_path__ + "pc/img/body_basic 4.59b18528.jpg";